import { _ as __rest, a as __assign } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import React__default, { useEffect } from 'react';
import { P as Popover } from '../../index-b7606a36.js';
import 'react-spring';
import 'react/jsx-runtime';
import 'react-dom';
import '../../useOrchard-45cfc194.js';
import '../../countries-34fea817.js';
import './IconButton.js';
import '../../skeleton.module-7c98b8f8.js';
import './TextLink.js';
import './Typography.js';
import '../../ResizeObserver-d78e3707.js';
import '../../CircleAlertIcon-a6cd83ad.js';
import '../../CloseIcon-25692563.js';
import '../../InfoIcon-22134611.js';
import '../../ThemeProvider-e3ab770b.js';

var styles = {"content":"InterfaceTooltip_content_aea2e4b2","target":"InterfaceTooltip_target_aea2e4b2"};

var InterfaceTooltip = function (_a) {
    var position = _a.placement, _b = _a.delay, delay = _b === void 0 ? 0 : _b, dataTestId = _a["data-testid"], className = _a.className, children = _a.children, content = _a.content, props = __rest(_a, ["placement", "delay", "data-testid", "className", "children", "content"]);
    var _c = React__default.useState(false), isHover = _c[0], setHover = _c[1];
    var _d = React__default.useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var handleMouseEnter = function () {
        setHover(true);
    };
    var handleMouseLeave = function () {
        setHover(false);
    };
    useEffect(function () {
        var id;
        var delayId;
        if (isHover) {
            delayId = window.setTimeout(function () {
                setIsOpen(true);
            }, delay);
        }
        else {
            id = window.setTimeout(function () {
                setIsOpen(false);
            }, 250);
        }
        return function () {
            window.clearTimeout(id);
            window.clearTimeout(delayId);
        };
    }, [delay, isHover]);
    return (React__default.createElement(Popover, __assign({ isOpen: isOpen, onClose: function () { return undefined; }, placement: position, showArrow: true, disableOverlay: true, disableScale: true, variant: "black", removePadding: true, content: React__default.createElement("div", { "data-testid": dataTestId, className: classNames(className, styles.content), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, content) }, props),
        React__default.createElement("div", { onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, className: styles.target }, children)));
};

export { InterfaceTooltip };
